module.exports = __webpack_public_path__ + "img/pattern_02.4bdfd26c.jpg";